// src/components/Admin/AdminBulkAddUsers.js
import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import api from '../../api/axios';

console.log('✅ AdminBulkAddUsers.js LOADED'); // <-- Add this line

const AdminBulkAddUsers = () => {
  const [groupName, setGroupName] = useState('');
  const [password, setPassword] = useState('');
  const [usernamesText, setUsernamesText] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setResult(null);

    const usernames = usernamesText
      .split('\n')
      .map(u => u.trim())
      .filter(u => u.length > 0);

    if (usernames.length === 0) {
      setError('Please enter at least one username.');
      setLoading(false);
      return;
    }

    try {
      const res = await api.post('/admin/bulk-add-users.php', {
        groupName,
        password,
        usernames
      });
      setResult(res.data);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-4" style={{ maxWidth: '600px' }}>
      <Card>
        <Card.Header as="h5">Bulk Add Users to Group</Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Group Name</Form.Label>
              <Form.Control
                type="text"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
                required
                placeholder="e.g., Group C"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Common Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Password for all users"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Usernames (one per line)</Form.Label>
              <Form.Control
                as="textarea"
                rows={8}
                value={usernamesText}
                onChange={(e) => setUsernamesText(e.target.value)}
                required
                placeholder="user1&#10;user2&#10;user3"
              />
            </Form.Group>

            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : 'Add Users'}
            </Button>
          </Form>

          {error && <Alert variant="danger" className="mt-3">{error}</Alert>}

          {result && (
            <Alert variant="success" className="mt-3">
              <p>{result.message}</p>
              {Array.isArray(result.inserted) && result.inserted.length > 0 && (
                <details>
                  <summary>Inserted: {result.inserted.length}</summary>
                  <pre>{result.inserted.join(', ')}</pre>
                </details>
              )}
              {Array.isArray(result.duplicates) && result.duplicates.length > 0 && (
                <details>
                  <summary>Duplicates (already existed): {result.duplicates.length}</summary>
                  <pre>{result.duplicates.join(', ')}</pre>
                </details>
              )}
            </Alert>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AdminBulkAddUsers;